import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { Page } from '../desktop/Page';

/** Shown inside the desktop window when a route throws (missing Suspense used to blank the whole shell). */
export function RouteError() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error ? error.message : 'Something went wrong';
  return (
    <Page title="This page failed to load" subtitle={message}>
      <Link className="tl-link" to="/">Back to launcher</Link>
    </Page>
  );
}
